import { Component } from "@angular/core";
import { AbstractModal } from "src/app/shared/components/modal/abstractModal";

@Component({
    templateUrl: "./new-navigation.html",
    standalone: false,
})
export class ControllerHeatHistoryComponent extends AbstractModal { }
